import * as cx from 'classnames';
import {
    bo_bank_payments_url,
    bo_banners_url,
    bo_card_payments_url,
    bo_customers_url,
    bo_invoices_url,
    bo_mail_ads_url,
    bo_revive_generate_gtad_url,
    bo_sms_payments_url,
    bo_social_campaigns_url,
} from 'mk/urls/functions';
import * as boUrls from 'mk2/apps/bo/urls';
import { CompatibleLink } from 'mk2/containers/SiteMenu/SiteMenu';
import { hasRequiredPermissions } from 'mk2/helpers/permissions';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { AppState, getRequestPermissions } from 'mk2/reducers';
import { MenuSelection } from 'mk2/schemas';
import * as React from 'react';
import { connect } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import styles from './BoTabs.mscss';

interface BoTabDefinition {
    name: string;
    title: string;
    url: string;
    permission: string | string[];
}

const BO_TABS: BoTabDefinition[] = [
    {
        name: 'customers',
        title: 'Pro Plus',
        url: bo_customers_url(),
        permission: 'vendor.can_manage_pro',
    },

    {
        name: 'social-marketing',
        title: 'Dni so značkou',
        url: bo_social_campaigns_url(),
        permission: 'bo.can_manage_ads',
    },
    {
        name: 'mail-ads',
        title: 'Reklama do IP',
        url: bo_mail_ads_url(),
        permission: 'bo.can_manage_ads',
    },
    {
        name: 'banners',
        title: 'Agencies',
        url: bo_banners_url(),
        permission: ['bo.can_manage_sales', 'bo.can_manage_finance', 'bo.can_manage_ads'],
    },
    {
        name: 'revive',
        title: 'DoubleClick',
        url: bo_revive_generate_gtad_url(),
        permission: 'bo.can_manage_ads',
    },

    {
        name: 'bank-payments',
        title: 'Bank Payments',
        url: bo_bank_payments_url(),
        permission: 'bo.can_manage_finance',
    },
    {
        name: 'card-payments',
        title: 'Card Payments',
        url: bo_card_payments_url(),
        permission: 'bo.can_manage_finance',
    },
    {
        name: 'sms-payments',
        title: 'SMS Payments',
        url: bo_sms_payments_url(),
        permission: 'bo.can_manage_finance',
    },
    {
        name: 'invoices',
        title: 'Invoices',
        url: bo_invoices_url(),
        permission: 'bo.can_manage_finance',
    },

    {
        name: 'orders',
        title: 'Orders',
        url: boUrls.boOrders,
        permission: ['bo.can_manage_sales', 'bo.can_manage_finance', 'bo.can_manage_ads'],
    },
];

interface OwnProps {
    menuSelection?: MenuSelection;
    fluxibleCompatibility: boolean;
}

interface StateProps {
    requestUserPermissions: string[];
}

interface DispatchProps {}

type Props = OwnProps & StateProps & DispatchProps;

class BoTabs extends React.Component<Props> {
    public render() {
        const { requestUserPermissions, menuSelection, fluxibleCompatibility } = this.props;
        const activeItem = menuSelection && menuSelection.activeItem;

        return (
            <div className={styles.BoTabs}>
                {BO_TABS.map((tab, i) => (hasRequiredPermissions(requestUserPermissions, tab.permission)
                    ? (
                        <CompatibleLink
                            key={tab.name}
                            className={cx(
                                styles.BoTabs__tab,
                                (activeItem === tab.name) && styles['BoTabs__tab--selected'],
                            )}
                            to={tab.url}
                            fluxibleCompatibility={tab.name !== 'orders' || fluxibleCompatibility}
                        >
                            {tab.title}
                        </CompatibleLink>
                    ) : null
                ))}

                <ReduxToastr
                    position="top-center"
                    transitionIn="fadeIn"
                    transitionOut="fadeOut"
                />
            </div>
        );
    }
}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    return {
        requestUserPermissions: getRequestPermissions(state),
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {};

export default connect(mapStateToProps, mapDispatchToProps)(BoTabs);
